import _ from 'lodash'

import { defaultOptions } from '../../utils'
import { AvatarPieceBase } from '../Base'
import { Style as AvatarNoseStyle1 } from './Style1'
import { Style as AvatarNoseStyle2 } from './Style2'
import { Style as AvatarNoseStyle3 } from './Style3'

export const NAME = 'nose'
export const STYLES = {
  style3: AvatarNoseStyle3,
  style2: AvatarNoseStyle2,
  style1: AvatarNoseStyle1
}
export const INLINE_STYLE = {
  width: '220%',
  height: 'auto',
  left: '50%',
  top: 0,
  position: 'absolute',
  pointerEvents: 'none',
  transform: 'translateX(-50%) translateY(-5%)'
}
export const AvatarNose = ({ style, color: colorSlug, ...rest }) => {
  const colorOptions = _.get(defaultOptions, `${NAME}.colors`, [])
  const color = _.find(colorOptions, { slug: colorSlug }) || colorOptions[0]
  const colors = color.colors

  return (
    <AvatarPieceBase
      STYLES={STYLES}
      style={style}
      colors={colors}
      inlineStyle={INLINE_STYLE}
      {...rest}
    />
  )
}
